export default __webpack_public_path__ + "static/media/capsule-open-large.a7003713.png";